import { queryOptions } from "@tanstack/react-query";
import api, { ApiCatalog, type ExtendedRequestInit } from "@/api";
import type {
  UserClassroomsFilters,
  UserClassroomsResponse,
} from "./queries.types";

type fetchUserClassroomsParams = {
  filters?: UserClassroomsFilters;
  options?: ExtendedRequestInit | undefined;
};

export const fetchUserClassrooms = ({
  filters = {},
  options = {},
}: fetchUserClassroomsParams) =>
  api().get<UserClassroomsResponse>(ApiCatalog.classroomsThroughUser.endpoint, {
    queryParams: filters,
    ...options,
  });

export const userClassroomsQueries = {
  all: () => [ApiCatalog.classroomsThroughUser.key] as const,
  list: (options?: ExtendedRequestInit) =>
    queryOptions({
      queryKey: [...userClassroomsQueries.all()],
      queryFn: () => fetchUserClassrooms({ options }),
    }),
  filter: (filters: UserClassroomsFilters, options?: ExtendedRequestInit) =>
    queryOptions({
      queryKey: [...userClassroomsQueries.all(), filters].filter(Boolean),
      queryFn: () => fetchUserClassrooms({ filters, options }),
    }),
};
